import React from "react";

import BasePersonelServiceItem from "./BasePersonelServiceItem";

// #region Utils
import { SERVICE_TYPES } from "@routebot/constants";
// #endregion Utils

const TransferPersonelServiceItem = ({ itemId, onClose, isNewItem, gotoItem, DeleteItem, UpdateItem, InsertItem }) => {
  const config = {
    // Context data key
    contextDataKey: "standartPersonelServices",

    // Form fields
    hasShift: false,
    hasDate: false,

    // Service type
    serviceType: SERVICE_TYPES.TRANSFER_PERSONEL,
  };

  return (
    <BasePersonelServiceItem
      itemId={itemId}
      onClose={onClose}
      isNewItem={isNewItem}
      gotoItem={gotoItem}
      DeleteItem={DeleteItem}
      UpdateItem={UpdateItem}
      InsertItem={InsertItem}
      config={config}
    />
  );
};

export default TransferPersonelServiceItem;
